import { gql } from '../../__generated__/gql'

export const COMMUNITY_HIDE_POST_MUTATION = gql(`
    mutation hideCommunityPost( $postId: Int! ) {
      hideCommunityPost(input: { postId: $postId }) {
        clientMutationId
      }
    }
`)
